import React from "react";

const styleCell = (cellValues) => {
    return (
        <div style={{
            color: "#092C4B", fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 'normal',
            fontSize: '12px', lineHeight: '12px', letterSpacing: '0.5px', cursor: 'default'
        }}
        >
            {cellValues.value}
        </div >
    );
}

export const columnsFr = [
    {
        field: 'channelName', headerName: 'Chaîne', headerClassName: 'headerNameDatagrid', width: 150, cellClassName: 'channelNameDatagrid',
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'packageTv', headerName: 'Bouquet', headerClassName: 'headerNameDatagrid', width: 145,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'position', headerName: 'Position', headerClassName: 'headerNameDatagrid', width: 115, valueGetter: (params) => { return reformatOrbitalPosition(params.row.satellite.orbitalPosition); },
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'satellite', headerName: 'Satellite', headerClassName: 'headerNameDatagrid', width: 150, valueGetter: (params) => { return params.row.satellite.name },
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'language', headerName: 'Langues', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    { field: 'sdHd', headerName: 'Résolution', headerClassName: 'headerNameDatagrid', width: 125, renderCell: (cellValues) => { return styleCell(cellValues) } },
    {
        field: 'encrypted', headerName: 'Encryptage', headerClassName: 'headerNameDatagrid', width: 150,
        valueGetter: function (params) {
            if (params.row.encrypted) {
                return 'Free-to-air'
            } else {
                return 'Encoded'
            }
        }, renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    { field: 'theme', headerName: 'Thème', headerClassName: 'headerNameDatagrid', width: 115, renderCell: (cellValues) => { return styleCell(cellValues) } },
    { field: 'type', headerName: 'Type', headerClassName: 'headerNameDatagrid', width: 110, renderCell: (cellValues) => { return styleCell(cellValues) } }
];





export const columnsEn = [
    {
        field: 'channelName', headerName: 'Channel', headerClassName: 'headerNameDatagrid', width: 150, cellClassName: 'channelNameDatagrid',
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'packageTv', headerName: 'Package', headerClassName: 'headerNameDatagrid', width: 145,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'position', headerName: 'Position', headerClassName: 'headerNameDatagrid', width: 115,
        renderCell: (cellValues) => { return styleCell(cellValues) }, valueGetter: (params) => { return reformatOrbitalPosition(params.row.satellite.orbitalPosition); }
    },
    {
        field: 'satellite', headerName: 'Satellite', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }, valueGetter: (params) => { return params.row.satellite.name }
    },
    {
        field: 'language', headerName: 'Language', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'sdHd', headerName: 'Resolution', headerClassName: 'headerNameDatagrid', width: 125,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'encrypted', headerName: 'Encryption', headerClassName: 'headerNameDatagrid', width: 150,
        valueGetter: function (params) {
            if (params.row.encrypted == "Clear") {
                return 'Free-to-air'
            } else if (params.row.encrypted == "Encrypted") {
                return 'Encoded'
            }
        },
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    { field: 'theme', headerName: 'Genre', headerClassName: 'headerNameDatagrid', width: 115, renderCell: (cellValues) => { return styleCell(cellValues) } },
    { field: 'type', headerName: 'Type', headerClassName: 'headerNameDatagrid', width: 110, renderCell: (cellValues) => { return styleCell(cellValues) } }
];


export const columnsSatellite = [
    {
        field: 'name', headerName: 'Satellite Whatsat', headerClassName: 'headerNameDatagrid', width: 170, cellClassName: 'channelNameDatagrid',
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'orbitalPosition', headerName: 'OrbitalPosition', headerClassName: 'headerNameDatagrid', width: 145,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'orbitSlot', headerName: 'orbitSlot', headerClassName: 'headerNameDatagrid', width: 115,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'satelliteLaunchYear', headerName: 'satellite Launch Year', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'satelliteExpectedEOL', headerName: 'satelliteExpectedEOL', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'aliasSatellite', headerName: 'Satellite BO', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'orderSatellite', headerName: 'orderSatellite', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },{
        field: 'actifSatellite', headerName: 'actifSatellite', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    },
    {
        field: 'status', headerName: 'status', headerClassName: 'headerNameDatagrid', width: 150,
        renderCell: (cellValues) => { return styleCell(cellValues) }
    }
];

function reformatOrbitalPosition(orbitalPosition) {
    if (orbitalPosition != null) {
        if (orbitalPosition !== undefined) {
            var data = orbitalPosition.split("°");
            var value = data[0].trim();
            var position = data[1];

            orbitalPosition = parseFloat(value) + "° " + position;
        }
    }
    return orbitalPosition;
}